import { memo } from 'react';

import { ConfirmationDialog } from '../../designSystem/ConfirmationDialog';
import { ToastDialog } from '../../designSystem/ToastDialog';
import { DialogState } from './types';

interface DialogContainerProps {
  dialogs: DialogState[];
  onClose: (id: string) => void;
}

const DialogContainerBase = ({ dialogs, onClose }: DialogContainerProps) => {
  return (
    <>
      {dialogs.map((dialog) => {
        const closeOnConfirm = dialog.closeOnConfirm ?? true;

        if (dialog.type === 'confirm') {
          return (
            <ConfirmationDialog
              key={dialog.id}
              {...dialog.config}
              trigger={null}
              onCancel={() => {
                dialog.config.onCancel?.();
                onClose(dialog.id);
              }}
              onConfirm={() => {
                dialog.config.onConfirm?.();

                if (closeOnConfirm) onClose(dialog.id);
              }}
            />
          );
        }

        if (dialog.type === 'toast') {
          return (
            <ToastDialog
              key={dialog.id}
              {...dialog.config}
              trigger={null}
              onConfirm={() => {
                dialog.config.onConfirm?.();

                if (closeOnConfirm) onClose(dialog.id);
              }}
            />
          );
        }

        return null;
      })}
    </>
  );
};

export const DialogContainer = memo(DialogContainerBase);
